import { useAppTheme } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'
import { useEffect } from 'react'
import Animated, { useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated'

// Пульсирующая каретка полей ввода (2×24, #1169f7). Blink — в UI-потоке.
export function Caret({ height = 24 }: { height?: number }) {
  const theme = useAppTheme()
  const opacity = useSharedValue(1)

  useEffect(() => {
    opacity.value = withRepeat(withTiming(0.15, { duration: 480 }), -1, true)
  }, [opacity])

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }))

  return (
    <Animated.View
      style={[
        animatedStyle,
        { backgroundColor: theme.COLOR_ICON_BRAND, borderRadius: rw(1), height: rh(height), width: rw(2) }, // color dark-light theme verified
      ]}
    />
  )
}
